/**
 * Where uploaded files are actually served from.
 *
 * Uploads live on the API host, not the web host. A bare `/uploads/...`
 * resolves against rv.parktle.com, whose SPA fallback answers 200 with
 * index.html for any unmatched path — so an <img> receives HTML and renders
 * broken with nothing in the console to explain it. That exact shape of bug
 * has now bitten twice: once for avatars, once for the whole API base.
 *
 * One helper, so the third time cannot happen in a new component.
 */
const uploadsOrigin = () => {
  const base = import.meta.env.VITE_API_BASE_URL;
  // Dev has no base URL: vite proxies /uploads alongside /api, so relative wins.
  if (!base) return '';
  try {
    return new URL(base, window.location.origin).origin;
  } catch {
    return '';
  }
};

/**
 * Absolute URL for a stored relative path.
 *
 * Takes the path the API returns ("facilities/ab12….jpg") and nothing else —
 * the column never holds an absolute URL, because one written into the
 * database is wrong the moment the host or scheme changes.
 */
export const uploadUrl = (path) => (path ? `${uploadsOrigin()}/uploads/${path}` : null);
